/* eslint max-len:0*/
import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../../../constants/dataAids';
import { determineStyles } from '../utils/ProductUtils';
import ProductListItem from './ProductListItem';

const FALLBACK_PRODUCT_IMAGE_URL = '//onlinestore.wsimg.com/assets/themes/__master/assets/images/product_group_item_placeholder_image.jpg';

class PlaceholderProductList extends React.Component {
  constructor() {
    super(...arguments);

    this.getSampleImage = this.getSampleImage.bind(this);
  }

  getSampleImage(index) {
    const { sampleImages = [] } = this.props;
    const image = sampleImages[index] && sampleImages[index].image;

    if (image) return image;

    return FALLBACK_PRODUCT_IMAGE_URL;
  }

  render() {
    const translate = this.context.translate || (() => {});
    const { Container, Block } = UX2.Element;
    const { Grid, Grid: { Cell } } = UX2.Component;
    const { renderMode } = this.props;

    const styles = {
      wrapper: {
        width: '60%',
        marginVertical: '0',
        marginHorizontal: 'auto',
        paddingVertical: 'large'
      },
      text: {
        marginTop: 'medium',
        marginBottom: 'large',
        fontFamily: 'arial,sans-serif',
        fontColor: 'lowContrast',
        textAlign: 'center',
        textTransform: 'none',
        fontWeight: 'bold',
        fontSize: '24px'
      },
      grid: {
        justifyContent: 'start'
      }
    };

    const name = translate('products.sample_product');

    const products = [{
      name,
      price: '9.00',
      slug: 'test-1',
      assets: [{ large_url: this.getSampleImage(0) }]
    }, {
      name,
      price: '15.00',
      slug: 'test-2',
      assets: [{ large_url: this.getSampleImage(1) }]
    }, {
      name,
      price: '12.99',
      slug: 'test-3',
      assets: [{ large_url: this.getSampleImage(2) }]
    }];

    const perPage = 3;
    const productsPerRow = 3;
    const getStyles = determineStyles.bind(null, productsPerRow);

    return (
      <Container>
        <Block style={ styles.wrapper }>
          <Grid data-aid={ dataAids.PRODUCT_LIST_RENDERED } data-products-per-page={ perPage } xs={ 1 } sm={ 3 } md={ productsPerRow } style={ styles.grid }>
            {products.map(product => {
              return (
                <Cell key={ product.slug } style={{ marginBottom: 'large' }}>
                  <ProductListItem product={ product } getStyles={ getStyles } renderMode={ renderMode } />
                </Cell>
              );
            })}
          </Grid>
        </Block>
      </Container>
    );
  }
}

PlaceholderProductList.propTypes = {
  renderMode: PropTypes.string,
  sampleImages: PropTypes.array
};

PlaceholderProductList.contextTypes = {
  translate: PropTypes.func
};

export default PlaceholderProductList;
